import Link from "next/link";

export const Links = ({ showLinks }: any) => {
  const linksData = [
    {
      href: "/about",
      text: "About Us",
      show: true,
    },
    {
      href: "/policy/returns",
      text: "Returns & Exchanges",
      show: showLinks.returnsAndExchangePolicy,
    },
    {
      href: "/policy/terms",
      text: "Terms & Conditions",
      show: showLinks.termsOfUsePolicy,
    },
  ];

  return (
    <div
      className={[
        "max-md:ml-0",
        "max-md:w-full",
        "justify-center",
        "max-md:px-5",
        "mr-2",
        "flex flex-col gap-4 justify-start",
      ].join(" ")}
    >
      <p className={["text-[20px] leading-[25.4px] font-semibold"].join(" ")}>
        Links
      </p>
      <div className={["gap-1 flex flex-col"].join(" ")}>
        {linksData.map(
          (link, index) =>
            link.show && (
              <Link
                key={`link_${index}`}
                className="underline"
                href={link.href}
              >
                {link.text}
              </Link>
            )
        )}
      </div>
    </div>
  );
};
